module.exports = __webpack_public_path__ + "static/media/pain-overview-large@2x.20fa031b.png";